module.exports = __webpack_public_path__ + "img/empty.1452ff3d.png";